"use client";

import {
  Button,
  Dialog,
  DialogClose,
  DialogCloseButton,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@medimo/ui";
import { ChevronRight } from "lucide-react";
import { useState } from "react";
import { useChangePasswordForm } from "../../hooks/use-change-password-form";
import { PasswordInput } from "../password-input";

export const ChangePasswordDialog = () => {
  const [open, setOpen] = useState(false);
  return (
    <Dialog open={open} onOpenChange={(open) => setOpen(open)}>
      <DialogTrigger asChild>
        <Button
          variant="ghost"
          className="h-auto px-0 py-0 font-bold text-lg text-primary hover:text-primary"
        >
          変更
          <ChevronRight />
        </Button>
      </DialogTrigger>
      <DialogContent className="flex w-[90%] flex-col gap-4">
        <DialogHeader>
          <DialogTitle>パスワードの変更</DialogTitle>
          <DialogCloseButton />
        </DialogHeader>
        <ChangePasswordForm onSubmitSuccessful={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  );
};

const ChangePasswordForm = ({
  onSubmitSuccessful,
}: {
  onSubmitSuccessful: VoidFunction;
}) => {
  const { form, onSubmit } = useChangePasswordForm({ onSubmitSuccessful });
  return (
    <Form {...form}>
      <form
        className="flex flex-col gap-4"
        onSubmit={form.handleSubmit(onSubmit)}
      >
        <FormField
          control={form.control}
          name="oldPassword"
          render={({ field }) => (
            <FormItem>
              <FormLabel>現在のパスワード</FormLabel>
              <FormControl>
                <PasswordInput role="textbox" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="newPassword"
          render={({ field }) => (
            <FormItem>
              <FormLabel>新しいパスワード</FormLabel>
              <FormControl>
                <PasswordInput role="textbox" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="confirmPassword"
          render={({ field }) => (
            <FormItem>
              <FormLabel>新しいパスワード（確認用）</FormLabel>
              <FormControl>
                <PasswordInput
                  role="textbox"
                  {...field}
                  onBlur={() => {
                    field.onChange(field.value.trim());
                    field.onBlur();
                  }}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <div className="flex gap-3 md:justify-end">
          <DialogClose asChild>
            <Button
              className="w-full font-bold md:w-1/4"
              type="button"
              variant="outline_green"
            >
              キャンセル
            </Button>
          </DialogClose>
          <Button className="w-full font-bold md:w-1/4" type="submit">
            変更
          </Button>
        </div>
      </form>
    </Form>
  );
};
